(function(exports) {
    "use strict";

    exports.getAzureProviderRelationship = function getAzureProviderRelationship(accountAlias, token) {
        return Application.promisify(atlas.ajax({
            url: "/accounts/" + accountAlias + "/relationships/azure",
            data: "json",
            method: "GET",
            beforeSend: function(xhr){xhr.setRequestHeader('Authorization', ("Bearer " + token));},
        }));
    };

    exports.createAzureProviderRelationship = function createAzureProviderRelationship(accountAlias, token) {
        return Application.promisify(atlas.ajax({
            url: "/accounts/" + accountAlias + "/relationships/azure",
            data: "json",
            method: "POST",
            beforeSend: function(xhr){xhr.setRequestHeader('Authorization', ("Bearer " + token));}
        }));
    };

    exports.checkTermsAndConditions = function checkTermsAndConditions(accountAlias, token) {
        return exports.getAzureProviderRelationship(accountAlias, token).then(function(providerRelationship) {
            console.log("Provider relationship object: ", providerRelationship);

            return providerRelationship.accountAlias !== undefined;
        }).catch(function() {
            return false;
        });
    };
}(typeof exports === "undefined" ? this.ProviderRelationship = {} : exports));


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/js/providerRelationships.jasset
 ** module id = 994
 ** module chunks = 0
 **/